import Guard from '@/services/middleware'


const ExternalLayout = () => import('@/layouts/ExternalLayout')
import TermsOfUser from '@/views/web/terms-use.vue'
import PrivacyPolicy from '@/views/web/privacy.vue'

export default [
    {
        path: '/termos-de-uso',
        component: ExternalLayout,
        beforeEnter: [Guard.checkResellerData],
        children: [
            { path: '', name: 'terms.terms-of-use', component: TermsOfUser, meta: { title: 'Termos de uso' } },
        ],
    },
    {
        path: '/politicas-de-privacidade',
        component: ExternalLayout,
        beforeEnter: [Guard.checkResellerData],
        children: [
            { path: '', name: 'terms.privacy', component: PrivacyPolicy, meta: { title: 'Políticias de privacidade' } },
        ],
    },
]